export const openSideContent = () => {
  return {
    type: "OPEN_SIDE_CONTENT",
  };
};
